import React from 'react'
import Slider from '../Slider/Slider'

export default function HirePhpDev() {
  return (
    <>
        <div class="inner-page" id="nodejs-design-bg" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="inner_content" data-aos="fade-up" data-aos-duration="2000">
                            <h1>Hire Php Developer</h1>
                            <div aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="index.html"><i
                                                class="ri-home-4-line"></i>Home</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Hire php Developer</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <section class="section" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="heading row_gaping">
                    <h2 class="section-title-2 text-center">Engage php Experts at the Best rates</h2>
                </div>
                <div class="center-row row row-below g-2 row-cols-lg-6 row-cols-sm-3 row-cols-2">
                    <div class="col-md text-center">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-1.png"  alt=""/>
                            <h5>One Week Free Trial</h5>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-2.png"  alt=""/>
                            <h5>Minimum 3+ Years of Experience</h5>
                        </div>
                      
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-3.png"  alt=""/>
                            <h5>Non-Disclosure Agreement</h5>
                      </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-4.png"  alt=""/>
                          
                            <h5>Flexible Hiring Models</h5>
                       </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                        <img src="assets/image/hire-angular-icon-5.png"  alt=""/>
                           
                        <h5>Competitive Rate</h5>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                        <img src="assets/image/hire-angular-icon-6.png"  alt=""/>
                        <h5>Source Code Delivery</h5>
                        </div>
                    </div>
                </div>
                <div class="btn_sec text-center row-below">
                    <a href="" class="btn1 btn_gap">Meet The Team</a>
                   <a href="" class="btn3">Recent Projects</a>
                    
                </div>
            </div>
        </section>

        <section class="section hire_content_anguler" data-aos="fade-up" data-aos-duration="1500">
            <div class="small-hire">
                
               <div class="row">
                <div class="col-lg-6 ml-auto">
                    <div class="small_hire_content">
                        <h3>WHAT CAN WE DO FOR YOU?</h3>
                        <p>We would be happy to discuss the project with you in person</p>
                        <h3 class="h3">Call us on <a href="telto:8420197208">+91 8420197208</a> </h3>
                        <div class="btn_sec">
                            <a href="" class="btn2">DROP IN A MESSAGE</a>
                        </div>
                    </div>
                </div>
               </div>
            </div>
        </section>

        <section class="section" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
               <div class="heading">
                <h2 class="section-title">Hire Offshore php Developers to  Meet <br/> Custom Requirements</h2>
                <p class="section-subtitle pt-3">Seize the opportunity to hire skilled offshore PHP developers for your projects. Our developers bring diverse expertise to the table, delivering high-quality PHP solutions tailored to your business needs. With flexible engagement models, we cater to the complexity and duration of your projects. Enjoy the benefits of cost-effective offshore development while maintaining quality and confidentiality. </p>
               </div>

                <div class="row mb-5">
                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-7.png"  alt=""/>
                            <h6 class="details-heading">Custom php Development</h6>
                            <p>Elevate your digital presence with our custom PHP development services. Our expert PHP developers craft bespoke solutions, aligning seamlessly with your unique business requirements. Whether you need a dynamic website, a robust web application, or intricate backend development, we tailor our PHP expertise to meet your goals.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-8.png"  alt=""/>
                            <h6 class="details-heading">API Integration</h6>
                            <p class="">Enhance your user experience with our expert PHP API integration services. We specialize in seamlessly connecting your PHP applications to various APIs, ensuring a smooth and interactive experience for your users. Whether it's integrating social media logins, payment gateways, or third-party services, our skilled PHP developers ensure secure and efficient data exchange.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card  ">
                            <img src="assets/image/hire-angular-icon-9.png"  alt=""/>
                            <h6 class="details-heading">Ajax Integration</h6>
                            <p class="">Elevate your PHP web applications with our Ajax integration services, ensuring dynamic and responsive user experiences. Our skilled PHP developers seamlessly implement Ajax, enabling real-time updates and interactive features without full-page reloads. Whether it's dynamic content loading, form submissions, or live updates, we optimize your PHP applications for enhanced interactivity.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card  ">
                            <img src="assets/image/hire-angular-icon-10.png"  alt=""/>
                            <h6 class="details-heading">Migration</h6>
                            <p class="">Upgrade your PHP applications effortlessly with our migration services. Whether transitioning between PHP versions or migrating from other frameworks, our expert PHP developers ensure a smooth and efficient process</p>
                        </div>
                    </div>
                    <div class="col-md-6 py-2">
                        <div class="bg-white  req-card ">
                            <img src="assets/image/hire-angular-icon-11.png"  alt=""/>
                            <h6 class="details-heading">Support & Maintenance</h6>
                            <p class="py-2">Ensure the continuous optimal performance of your PHP web applications with our dedicated support and maintenance services. Our expert PHP developers are committed to promptly resolving issues, applying updates, and proactively monitoring for potential challenges.</p>
                        </div>
                    </div>
                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-12.png"  alt=""/>
                            <h6 class="details-heading">Ecommerce Development</h6>
                            <p class="py-2">Revolutionize your online business with our expert PHP Ecommerce development services. Our skilled PHP developers specialize in crafting robust, scalable, and feature-rich Ecommerce solutions tailored to your unique business needs.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>       

        <section class="section bg_color" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
              <div class="heading  text-center">
                <h2>Why Choose Us</h2>
              </div>
                <div class="row g-3 ">
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-13.png"  alt=""/>
                            </div>
                            <h5 class="my-3">Industry Experts</h5>
                            <p>Our in-house team is enriched with trusted and experienced developers - no freelancer.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-14.png"  alt=""/>
                            </div>
                            <h5 class="my-3">Widely recommended</h5>
                            <p>We got hundreds of real 5-star ratings and reviews on Google, GoodFirms, and Clutch
                                combined. </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-15.png"  alt=""/>
                            </div>
                            <h5 class="my-3">Customer Service
                            </h5>
                            <p>Our zero complaint work approach helps us to ensure a seamless customer experience.


                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-16.png"  alt=""/>
                            </div>
                            <h5 class="my-3">Ideal Workplace
                            </h5>
                            <p>We cultivate a productive work environment with a trendy setup to enhance the outcomes.


                            </p>
                        </div>
                    </div>
                    <div class="row-below btn_sec text-center">
                        <a href="" class="btn2 btn_gap">Get Started</a>
                        <a href="" class="btn2"> Our Clients</a>
                    
                    </div>
                </div>
            </div>
        </section>

        <section class="showcasing_sec" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <div class="heading" data-aos="fade-down" data-aos-duration="2500">
                            <h2>Showcasing our Expertise</h2>
                            <p>
                                Transform your online business into a seamless and efficient platform with our Laravel Ecommerce development services. Our expert Laravel developers specialize in creating robust and scalable Ecommerce solutions tailored to your unique business needs.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="owl-carousel owl-theme showcasing_slider">
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>php company in the world</h4>
                                                <p>
                                                    Join forces with the leading PHP company in the world – [Your Company Name]. Our global presence is rooted in delivering unparalleled PHP development services. As pioneers in the industry, our expert PHP developers combine innovation with technical mastery to create robust and scalable solutions. Whether you seek dynamic web applications, custom PHP development, or Ecommerce solutions, we tailor our expertise to your specific needs.
                                                </p>
                                                <p>
                                                    Join a league of satisfied clients who have witnessed the transformative power of our PHP solutions. Contact us at [your@email.com] to embark on a global journey of PHP excellence with [Your Company Name].
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid"  alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>php Development Technologies</h4>
                                                <p>
                                                    At adret software, we harness the latest PHP development technologies to propel your projects to new heights. Our skilled PHP developers leverage frameworks like Laravel and CodeIgniter, ensuring robust and efficient solutions. With expertise in PHP 7 and beyond, we embrace the language's modern features for enhanced performance.
                                                </p>
                                                <p>
                                                    Whether it's integrating with databases like MySQL or utilizing tools like Composer for dependency management, our development stack is curated for excellence. Explore the possibilities of PHP development with us. Contact us at  to discuss how our adept use of PHP technologies can elevate your web applications to the next level.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid"  alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>php App Development</h4>
                                                <p>
                                                    Discover the power of innovation with our PHP app development services at Adret software. Our adept PHP developers specialize in crafting dynamic and feature-rich applications tailored to your unique needs. Whether you're envisioning a custom web app, a scalable business application, or a robust backend system, we leverage PHP's versatility for optimal results. 
                                                </p>
                                                <p>
                                                    Embrace cutting-edge PHP frameworks, seamless database integration, and a user-centric approach to ensure your app stands out in the digital landscape.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid"  alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
 
        <Slider/>

        <section class="section careers_sec1" id="faq_sec" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h2 class="section-title ">Php Development – Frequently Asked Question</h2>
                            <p class="section-subtitle">Clarify your doubts about Php before availing Php
                                development services.</p>
                            <div class="col-md-12">
                                <div class="accordion">

                                    <div class="accordion__item">
                                        <h2 class="accordion__title">How do I get started with your Php
                                            services?</h2>
                                        <div class="accordion__body">
                                            <p>Starting with our PHP services is simple and tailored to your needs. Begin by reaching out to us at [your@email.com], expressing your project requirements and goals. Our dedicated team will promptly engage with you, offering insights and understanding the scope of your PHP development needs. Following a comprehensive consultation, we'll outline a strategic plan, including timelines and milestones.</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">How do your php services benefit
                                            my business?</h2>
                                        <div class="accordion__body">
                                            <p>Our PHP services offer a myriad of advantages to propel your business forward. Experience accelerated development timelines, leveraging PHP's efficiency and extensive feature set for quicker time-to-market. Benefit from robust security measures, safeguarding sensitive data and ensuring a secure digital environment for your users.</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">Will it be possible to hire Php developers on
                                            demand for custom requirements?</h2>
                                        <div class="accordion__body">
                                            <p>Harness the flexibility of our services by hiring PHP developers on demand to meet your custom requirements. Whether you need specific features, ongoing support, or a complete PHP project, our flexible engagement models adapt to the complexity and duration of your needs. </p>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
